export const SERVER_CONFIG = {
  production: { 
    API_URL: "/",
    // URL_2C2P_REDIRECT: 'https://demo2.2c2p.com/2C2PFrontEnd/RedirectV3/payment',
    URL_2C2P_REDIRECT: 'https://t.2c2p.com/RedirectV3/payment',
  },
};
